/**
 * An error answer from a streaming endpoint, thrown by `createStreamingFetch`. `code` is the endpoint's own code from a
 * JSON body, unchecked, since a streaming endpoint's codes aren't backend `ErrorCode`s; `retryAt` comes from
 * `Retry-After`.
 */
export class StreamingHttpError extends Error {
    public readonly status: number;
    public readonly code: string | undefined;
    public readonly retryAt: Date | undefined;

    constructor({ status, code, retryAt }: { status: number; code?: string; retryAt?: Date }) {
        super(`Got ${status}${code === undefined ? '' : ` ${code}`} from a streaming endpoint`);
        this.name = 'StreamingHttpError';
        this.status = status;
        this.code = code;
        this.retryAt = retryAt;
    }
}
